import React from 'react';
import { windowPeriodLabel } from '../lib/windowLabel';

/**
 * The period a window panel's snapshot covers ("30 days to Oct 5"), under the panel title.
 *
 * @param {{snapshot: {period_start?: string|null, period_end?: string|null}|null|undefined}} props
 *   renders nothing when the snapshot names no end date
 */
export default function PeriodLabel({ snapshot }) {
  const label = windowPeriodLabel(snapshot);
  if (!label) return null;
  return (
    <p data-testid="period-label" className="text-[11px] text-gray-500 dark:text-gray-400">
      {label}
    </p>
  );
}
